<template>
  <div>
    <el-tabs v-model="activeName" style="z-index: 1;">
      <el-tab-pane :label="this.$t('runningReport.graph')" name="chart">
        <el-row :gutter="20">
          <el-col :span="8">
            <el-card class="box-card" shadow="never">
              <div class="dash-title">{{this.$t('runningReport.calling')}}</div>
              <div class="dash-value dash-num-blue">{{ calling }}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card" shadow="never">
              <div class="dash-title">{{this.$t('runningReport.durationAvg')}}</div>
              <div class="dash-value dash-num-blue">{{ duration }}</div>
            </el-card>
          </el-col>
          <el-col :span="8">
            <el-card class="box-card" shadow="never">
              <div class="dash-title">{{this.$t('runningReport.persent')}}</div>
              <div class="dash-value dash-num-blue">{{ persent * 100 }}%</div>
            </el-card>
          </el-col>
        </el-row>
        <br />

        <el-row
          style="background-color: #fff;margin-bottom: 8px;padding: 15px;"
        >
          <el-col :span="12">
            <span style="color:#999;margin-right: 15px;">{{this.$t('runningReport.newMonth')}}</span>
            <el-date-picker
              v-model="newMonth"
              type="month"
              :placeholder="this.$t('runningReport.month')"
              size="small"
              value-format="yyyyMM"
            >
            </el-date-picker>
          </el-col>
          <el-col :span="12"> </el-col>
        </el-row>

        <RunningChart :chartParams="chartParams" />

        <el-row :gutter="8">
          <el-col :span="12">
            <RobotRunningChart :chartRobotParams="chartRobotParams" />
          </el-col>
          <el-col :span="12">
            <FunctionRunningChart :chartFunctionParams="chartFunctionParams" />
          </el-col>
        </el-row>
      </el-tab-pane>

      <el-tab-pane :label="this.$t('runningReport.list')" name="list">
        <el-row>
          <el-col :span="6">
            <span class="dash-value dash-num-blue">{{ totalCallingList }}</span
            >&nbsp; <span class="dash-title">{{this.$t('runningReport.unit')}}</span>&nbsp;
          </el-col>
          <el-col :span="18">
            <SearchCriterial
              :handleReset="handleReset"
              :searchParams="searchParams"
              :handleChangeSearchParams="handleChangeSearchParams"
              :handleSearch="handleSearch"
            />
          </el-col>
        </el-row>
        <el-table
          :data="items"
          style="width: 100%;padding: 10px 10px 10px 10px;"
        >
          <el-table-column prop="date" :label="this.$t('runningReport.date')" width="140">
          </el-table-column>
          <el-table-column prop="robotName" :label="this.$t('runningReport.robotName')"> </el-table-column>
          <el-table-column prop="functionName" :label="this.$t('runningReport.functionName')"> </el-table-column>
          <el-table-column prop="callSum" :label="this.$t('runningReport.callSum')" width="120">
            <template slot-scope="scope">
              <div class="dash-num-blue">{{ scope.row.callSum }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="callSuccess" :label="this.$t('runningReport.callSuccess')" width="120">
            <template slot-scope="scope">
              <div class="dash-num-blue">{{ scope.row.callSuccess }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="callFail" :label="this.$t('runningReport.callFail')" width="120">
            <template slot-scope="scope">
              <div class="dash-num-blue">{{ scope.row.callFail }}</div>
            </template>
          </el-table-column>
          <el-table-column prop="duration" :label="this.$t('runningReport.duration')" width="140">
          </el-table-column>
        </el-table>
        <PageBar>
          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalCount"
            @current-change="handleCurrentChange"
            :current-page.sync="searchParams.pageIndex"
            :page-size="searchParams.pageSize"
          >
          </el-pagination>
        </PageBar>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import SearchCriterial from "@/components/robot/runningReport/SearchCriterial.vue";
import RunningChart from "@/components/robot/runningReport/RunningChart.vue";
import RobotRunningChart from "@/components/robot/runningReport/RobotRunningChart.vue";
import FunctionRunningChart from "@/components/robot/runningReport/FunctionRunningChart.vue";

import PageBar from "@/components/common/PageBar.vue";
import { callingReport } from "@/api/robot";
import { getTotal } from "@/api/analysis";
import { mapState } from "vuex";
const defaultSearchParams = {
  searchType: "",
  functionID: "",
  robotID: "",
  pageIndex: 1,
  pageSize: 10
};
export default {
  name: "RunningReport",
  components: {
    SearchCriterial,
    PageBar,
    RunningChart,
    RobotRunningChart,
    FunctionRunningChart
  },
  data: () => {
    return {
      searchParams: { ...defaultSearchParams },
      totalCount: 0,
      items: [],
      activeName: "chart",
      totalCallingList: 0,
      calling: 0,
      duration: 0,
      persent: 0,
      chartParams: { month: "" },
      chartRobotParams: { searchType: "1", month: "" },
      chartFunctionParams: { searchType: "2", month: "" }
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    ...mapState(["accountInfo"]),
    newMonth: {
      get() {
        return this.chartParams.month;
      },
      set(val) {
        this.chartParams = { month: val };
        this.chartRobotParams = { searchType: "1", month: val };
        this.chartFunctionParams = { searchType: "2", month: val };
      }
    }
  },
  methods: {
    refreshData() {
      getTotal({
        userID: this.accountInfo.userID
      }).then(response => {
        this.calling = response.data.totalRunning;
        this.duration = response.data.excuteTime;
        this.persent = response.data.ratio;
      });

      callingReport({
        userID: this.accountInfo.userID,
        ...this.searchParams
      }).then(response => {
        this.totalCallingList = response.data.totalCalling;
        this.totalCount = response.data.totalCount;
        this.items = response.data.items;
      });
    },
    handleCurrentChange(val) {
      this.searchParams = { ...this.searchParams, pageIndex: val };
      this.refreshData();
    },
    handleChangeSearchParams(searchParams) {
      this.searchParams = searchParams;
    },
    handleSearch() {
      this.searchParams = { ...this.searchParams, pageIndex: 1 };
      this.refreshData();
    },
    handleReset() {
      this.searchParams = { ...defaultSearchParams };
      this.refreshData();
    }
    //,
    //handleMonthChange(val) {
    //  this.chartParams = {"searchType":val};
    //  this.chartRobotParams = {"searchType":"1"};
    //}
  }
};
</script>
